import { Box, Button, Grid, IconButton, Typography } from "@mui/material";
import { colors } from "../styles/colors";
import RemoveIcon from '@mui/icons-material/Remove';
import Delete from '../assets/icons/Delete';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { ReactComponent as BedList } from '../assets/icons/BedList.svg';
import { ReactComponent as GuestsIcon } from '../assets/icons/Guests.svg';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CustomSelectInputListingPage from "./CustomSelectInputListingPage";

const GuestDropdown = ({ setRoom, room, totalChildren, totalInfantsChildren, guestRoomSubmit, selectedDestination, handleFind, closeDropdown }: any) => {
    const adults = room?.reduce((a: number, b: any) => a + b?.adults, 0);
    const childrens = room?.reduce(
        (a: number, b: any) => a + b?.children?.filter((item: { age: string }) => Number(item?.age) >= 2)?.length || 0,
        0
    );
    const infants = room?.reduce((a: number, b: any) => a + b?.infants.length, 0);
    const totalGuests = adults + childrens + infants
    const handleRemoveRoom = (index: number, event: any) => {
        setTimeout(() => {
            event.stopPropagation();
            const updatedRoom = [...room.slice(0, index), ...room.slice(index + 1)];
            setRoom(updatedRoom);
        }, 2)

    };

    const handleAgeChange = (roomIndex: number, childIndex: number, newAge: string, type: string, event: any) => {
        event.stopPropagation();
        if (type === "infants") {
            setRoom((prevRoom: any) => {
                const updatedRoom = [...prevRoom];
                const updatedChildren = [...updatedRoom[roomIndex].infants];
                updatedChildren[childIndex] = {
                    ...updatedChildren[childIndex],
                    age: newAge,
                };
                updatedRoom[roomIndex] = {
                    ...updatedRoom[roomIndex],
                    infants: updatedChildren,
                };
                return updatedRoom;
            });
        } else {
            setRoom((prevRoom: any) => {
                const updatedRoom = [...prevRoom];
                const updatedChildren = [...updatedRoom[roomIndex].children];
                updatedChildren[childIndex] = {
                    ...updatedChildren[childIndex],
                    age: newAge,
                };
                updatedRoom[roomIndex] = {
                    ...updatedRoom[roomIndex],
                    children: updatedChildren,
                };
                return updatedRoom;
            });
        }
    };

    const handleIncDecAdultOrChildren = (index: number, type: string, action: string, event: any) => {
        event.stopPropagation();
        let arr: any = [...room];

        switch (type) {
            case 'adult':
                if (action === 'dec') {
                    arr[index] = {
                        ...arr[index],
                        adults: arr[index].adults > 1 ? arr[index].adults - 1 : 1,
                    };
                } else {
                    arr[index] = {
                        ...arr[index],
                        adults: arr[index].adults ? arr[index].adults + 1 : 1,
                    };
                }
                break;

            case 'child':
                if (action === 'dec') {
                    const updatedChildren = arr[index].children.slice(0, -1);
                    arr[index] = {
                        ...arr[index],
                        children: updatedChildren,
                    };
                } else {
                    if (totalChildren.length < 6) {
                        const newChild = {
                            child: arr[index].children.length + 1,
                            age: '',
                        };
                        const updatedChildren = [...arr[index].children, newChild];
                        arr[index] = {
                            ...arr[index],
                            children: updatedChildren,
                        };
                    }
                }
                break;

            case 'infant':
                if (action === 'dec') {
                    const updatedChildren = arr[index].infants.slice(0, -1);
                    arr[index] = {
                        ...arr[index],
                        infants: updatedChildren,
                    };
                } else {
                    if (totalInfantsChildren.length < 6) {
                        const newChild = {
                            child: arr[index].infants.length + 1,
                            age: '',
                        };
                        const updatedChildren = [...arr[index].infants, newChild];
                        arr[index] = {
                            ...arr[index],
                            infants: updatedChildren,
                        };
                    }
                }
                break;
            default:
                break;
        }
        setRoom(arr);
    };
    const CustomSelectInputListingPageContent = ({
        index,
        i,
        type,
        closeDropdown,
    }: {
        index: number,
        i: number,
        type: "child" | "infant",
        closeDropdown?: () => void
    }) => {
        const options = type === "infant"
            ? [...Array(24)].map((_, ageIndex) => String(ageIndex))
            : [...Array(16)].map((_, ageIndex) => String(ageIndex + 2));
        const selectedAge = type === "infant"
            ? room[index]?.infants?.[i]?.age
            : room[index]?.children?.[i]?.age;
        return (
            <Box>
                <Box
                    sx={{
                        padding: "14px 12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "4px",
                        borderBottom: `1px solid${colors.grey[50]}`,
                        background: colors.basics.white,
                        maxHeight: '200px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}
                >
                    <Box display="flex" alignItems="center" gap="6px" fontWeight={400} fontSize={'14px'}>
                        {String(selectedAge) || 'Age'}
                    </Box>
                    {/* <CloseRoundedIcon onClick={() => closeDropdown?.()} sx={{ cursor: 'pointer' }} /> */}
                </Box>


                <Box sx={{ maxHeight: '220px', overflowY: 'auto' }}>
                    {
                        options.map((el) => {
                            return (
                                <Box
                                    key={el}
                                    onClick={(e) => {
                                        handleAgeChange(index, i, el, type === "infant" ? "infants" : "child", e);
                                        // Close only the age dropdown instance; parent rooms stays open.
                                        closeDropdown?.();
                                    }}
                                    sx={{
                                        py: "8px",
                                        px: "12px",
                                        cursor: "pointer",
                                        "&:hover": {
                                            backgroundColor: colors.basics.pink,
                                        },
                                    }}
                                >
                                    <Typography variant='body2' color={colors.grey[10]}>
                                        {el}
                                    </Typography>
                                </Box>
                            )
                        })
                    }
                </Box>
            </Box>
        )
    }
    return (
        <Box borderRadius='3px' position='relative' sx={{

        }}  >
            <Box sx={{
                position: "sticky",
                top: 0,
                zIndex: 2,
                background: colors.basics.white,
                borderBottom: `1px solid${colors.grey[50]}`,
                padding: "8px 16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "4px",
            }}>
                <Box display='flex' justifyContent='center' alignItems='center' fontSize={{ sm: '15px', xs: '14px' }}>
                    <GuestsIcon style={{ marginRight: '8px' }} /> {room.length}  {room.length >= 2 ? "Rooms" : "Room"} / {totalGuests} {totalGuests > 1 ? "Guests" : "Guest"}
                </Box>
                <Box onClick={(e) => { e.stopPropagation(); closeDropdown && closeDropdown(); }}>
                    <CloseRoundedIcon style={{ cursor: 'pointer' }} height='16px' width='16px' />
                </Box>

            </Box>
            {/* <Box sx={{
                maxHeight: 260,
                overflowY: "auto",
                padding: "10px 16px 10px 16px !important",
            }}>
                <Typography variant='body2' fontSize={{ sm: '15px', xs: '14px' }} fontWeight={400} color={colors.grey[10]} >
                    How many guests?
                </Typography>
            </Box> */}

            {/* <Box display='flex' alignItems='center' justifyContent='space-between'>
                <Typography variant='body2' fontSize={'18px'} color={colors.grey[10]}>
                    Rooms
                </Typography>
                <Box display='flex' alignItems='center'>
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            if (room.length >= 2) {
                                setRoom(room?.filter((item: any, index: number) => index !== room.length - 1))
                            }
                        }}
                        disableRipple={true}
                        sx={{ pt: 0, pb: 0 }}
                    >
                        <RemoveIcon sx={{ fill: colors.grey[10] }} />
                    </IconButton>
                    <Typography variant='body2' fontSize='18px' color={colors.grey[10]}>
                        {room?.length}
                    </Typography>
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            room.length < 5 &&
                                setRoom((item: any) => [
                                    ...item,
                                    {
                                        room: room.length + 1,
                                        adults: 2,
                                        children: [],
                                        infants: []
                                    },
                                ]);
                        }}
                        disableRipple={true}
                        sx={{ pt: 0, pb: 0 }}
                    >
                        <AddIcon sx={{ fill: colors.grey[10] }} />
                    </IconButton>
                </Box>
            </Box> */}
            <Box sx={{
                px: "16px",
                pt: "16px"
                // py: "8px"
            }}>
                {room?.map((item: object[] | any, index: number) => {
                    return (
                        <Box key={index} mb={2} border={`1px solid ${colors.grey[50]}`} borderRadius='10px' p={2} >
                            {/* <hr style={{ marginTop: 10, marginBottom: 10 }} /> */}
                            <Box mb={1} display='flex' alignItems='center' justifyContent={'space-between'}>
                                <Typography variant='body2' color={colors.grey[10]} mr={1} fontSize={{ sm: '15px', xs: '14px' }} fontWeight={700} display='flex' alignItems='center'>
                                    Room {index + 1} <BedList style={{ marginLeft: '4px' }} />
                                </Typography>
                                {room.length !== 1 && (
                                    <Box
                                        color={colors.basics.primary}
                                        sx={{
                                            cursor: 'pointer',
                                            '& svg': {
                                                '& path': { fill: colors.basics.primary },
                                                width: '18px',
                                                height: '18px',
                                            },
                                        }}
                                        onClick={(e) => handleRemoveRoom(index, e)}
                                    >
                                        <Delete />
                                    </Box>
                                )}
                            </Box>
                            <Box width="100%" display="flex" flexDirection="column" gap={1} minWidth='200px' sx={{
                                '& .MuiSvgIcon-root': {
                                    width: '20px',
                                    height: '20px',
                                }
                            }}>

                                {/* Adults */}
                                <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" gap={1}
                                >
                                    <Typography variant="body2" color={colors.basics.black} fontSize={{ sm: '15px', xs: '14px' }}>
                                        Adults
                                    </Typography>

                                    <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
                                        <IconButton
                                            onClick={(e) => handleIncDecAdultOrChildren(index, "adult", "dec", e)}
                                            disableRipple
                                            sx={{
                                                p: 0.5,
                                                borderRadius: "50px",
                                                backgroundColor: `${colors.basics.primary}`,
                                            }}
                                        >
                                            <RemoveIcon sx={{ fill: colors.basics.white }} />
                                        </IconButton>

                                        <Typography fontSize={{ sm: '15px', xs: '14px' }} color={colors.grey[10]} width='20px' align='center'>
                                            {room[index].adults}
                                        </Typography>

                                        <IconButton
                                            onClick={(e) => handleIncDecAdultOrChildren(index, "adult", "inc", e)}
                                            disableRipple
                                            sx={{
                                                p: 0.5,
                                                borderRadius: "50px",
                                                backgroundColor: `${colors.basics.primary}`,
                                            }}
                                        >
                                            <AddRoundedIcon sx={{ fill: colors.basics.white }} />
                                        </IconButton>
                                    </Box>
                                </Box>

                                {/* Children */}
                                <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" gap={1}>
                                    <Typography variant="body2" color={colors.basics.black} fontSize={{ sm: '15px', xs: '14px' }}>
                                        Child (2-11 years)
                                    </Typography>

                                    <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
                                        <IconButton
                                            onClick={(e) => handleIncDecAdultOrChildren(index, "child", "dec", e)}
                                            disableRipple
                                            sx={{
                                                p: 0.5,
                                                borderRadius: "50px",
                                                backgroundColor: room[index].children.length > 0 ? `${colors.basics.primary}` : `${colors.grey[50]}`,
                                                cursor: room[index].children.length > 0 ? 'pointer' : 'auto',
                                            }}
                                        >
                                            <RemoveIcon sx={{ fill: colors.basics.white }} />
                                        </IconButton>

                                        <Typography fontSize={{ sm: '15px', xs: '14px' }} color={colors.grey[10]} width='20px' align='center'>
                                            {room[index].children.length}
                                        </Typography>

                                        <IconButton
                                            onClick={(e) => handleIncDecAdultOrChildren(index, "child", "inc", e)}
                                            disableRipple
                                            sx={{
                                                p: 0.5,
                                                borderRadius: "50px",
                                                backgroundColor: room[index].children.length >= 6 ? `${colors.grey[50]}` : `${colors.basics.primary}`,
                                                cursor: room[index].infants.length >= 6 ? 'auto' : 'pointer',

                                            }}
                                        >
                                            <AddRoundedIcon
                                                sx={{
                                                    fill: colors.basics.white,
                                                    // backgroundColor: room[index].children.length >= 6 ? `${colors.grey[50]}` : `${colors.basics.primary}`,
                                                }}
                                            />
                                        </IconButton>
                                    </Box>
                                </Box>

                                {/* Infants */}
                                <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" gap={1}>
                                    <Typography variant="body2" color={colors.basics.black} fontSize={{ sm: '15px', xs: '14px' }}>
                                        Infant (0-23 months)
                                    </Typography>

                                    <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
                                        <IconButton
                                            onClick={(e) => handleIncDecAdultOrChildren(index, "infant", "dec", e)}
                                            disableRipple
                                            sx={{
                                                p: 0.5,
                                                borderRadius: "50px",
                                                backgroundColor: room[index].infants.length > 0 ? `${colors.basics.primary}` : `${colors.grey[50]}`,
                                                cursor: room[index].infants.length > 0 ? 'pointer' : 'auto',
                                            }}
                                        >
                                            <RemoveIcon sx={{ fill: colors.basics.white }} />
                                        </IconButton>

                                        <Typography fontSize="18px" color={colors.grey[10]} width='20px' align='center'>
                                            {room[index].infants.length}
                                        </Typography>

                                        <IconButton
                                            onClick={(e) => handleIncDecAdultOrChildren(index, "infant", "inc", e)}
                                            disableRipple
                                            sx={{
                                                p: 0.5,
                                                borderRadius: "50px",
                                                backgroundColor: room[index].infants.length >= 6 ? `${colors.grey[50]}` : `${colors.basics.primary}`,
                                                cursor: room[index].infants.length >= 6 ? 'auto' : 'pointer',
                                            }}
                                        >
                                            <AddRoundedIcon
                                                sx={{
                                                    fill: colors.basics.white

                                                }}
                                            />
                                        </IconButton>
                                    </Box>
                                </Box>
                            </Box>



                            {item?.children?.length > 0 && <Grid mt={3} container columnSpacing={1} >
                                <Box mb={"3px"} sx={{ color: "red", fontSize: "11px", marginLeft: "6px" }}>Please ensure that the child age is in line with the checkout date if they are booking in advance.</Box>

                                {item?.children?.map((element: any, i: number) => {
                                    return (
                                        <Grid key={i} marginTop={'0'} xs={4} item >
                                            <Box key={i}>
                                                <Typography variant='body2' color={colors.grey[10]} my={1}>
                                                    Child  {element.child} Age
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        flex: { sm: '0 0 30%', xs: '100%' },
                                                        // height: '40px',
                                                        '& .custom-dropdown-listing-page .dropdown-menu ': {
                                                            top: '-4.5px !important',
                                                            left: "-1px",
                                                            minWidth: '100% !important',
                                                        },
                                                    }}
                                                >
                                                    <CustomSelectInputListingPage
                                                        paddingStyle="0px"
                                                        radiusStyle="5px"
                                                        ids={`child-age-${index}-${i}`}
                                                        dropdownWidth={"100%"}
                                                        data={[...Array(16)].map((el, i) => String(i + 2))}
                                                        // placeholder='Age'
                                                        value={String(room[index]?.children[i]?.age) || ''}
                                                        onChange={(e: any, n: any, v: any) => handleAgeChange(index, i, v, "child", e)}
                                                        menuItemStyle={{ width: '100px' }}
                                                        children={<CustomSelectInputListingPageContent index={index} i={i} type="child" />}
                                                    />
                                                </Box>
                                            </Box>
                                        </Grid>
                                    );
                                })}
                            </Grid>}

                            {item?.infants?.length > 0 && <Grid mt={3} container columnSpacing={1} >
                                <Box mb={"3px"} sx={{ color: "red", fontSize: "11px", marginLeft: "6px" }}>Please ensure that the infant age is in line with the checkout date if they are booking in advance.</Box>

                                {item?.infants?.map((element: any, i: number) => {
                                    return (
                                        <Grid key={i} marginTop={'0'} xs={4} item>
                                            <Box key={i}>
                                                <Typography variant='body2' color={colors.grey[10]} my={1}>
                                                    Infant  {element.child} Months
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        flex: { sm: '0 0 30%', xs: '100%' },
                                                        // height: '40px',
                                                        '& .custom-dropdown-listing-page .dropdown-menu ': {
                                                            top: '-4.5px !important',
                                                            left: "-1px",
                                                            minWidth: '100% !important',
                                                        }
                                                    }}
                                                >
                                                    <CustomSelectInputListingPage
                                                        paddingStyle="0px"
                                                        radiusStyle="5px"
                                                        ids={`infant-age-${index}-${i}`}
                                                        data={[...Array(24)].map((el, i) => String(i))}
                                                        // placeholder='Month'
                                                        dropdownWidth={"100%"}
                                                        value={String(room[index]?.infants[i]?.age) || ''}
                                                        onChange={(e: any, n: any, v: any) => handleAgeChange(index, i, v, "infants", e)}
                                                        menuItemStyle={{ width: '100px' }}
                                                        children={<CustomSelectInputListingPageContent index={index} i={i} type="infant" />}
                                                    />
                                                    {/* <Box  sx={{ color: "red", fontSize: "11px", marginLeft: "1px",marginTop:"6px" }}>Please ensure the child age is in line with the checkout date if they are booking in advance.</Box> */}

                                                </Box>
                                            </Box>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                            }
                        </Box>
                    );
                })}
            </Box>
            <Box sx={{
                px: "16px",

                mb: "10px",
                "& .MuiButton-root ": {
                    width: "100%",
                    fontWeight: 700,
                    fontSize: "16px",
                    lineHeight: "130%",
                    fontFamily: "Raleway",
                    color: `${colors.basics.white} !important`,
                    backgroundColor: `${colors.basics.black} !important`,
                    border: `1px solid ${colors.basics.black} !important`,
                }
            }}>
                <Button sx={{
                    width: "100%",
                }} onClick={(e) => {
                    e.stopPropagation();
                    room.length < 5 &&
                        setRoom((item: any) => [
                            ...item,
                            {
                                room: room.length + 1,
                                adults: 2,
                                children: [],
                                infants: []
                            },
                        ]);
                }}>Add another room</Button>
            </Box>
            <Box sx={{
                px: "16px",
                py: "8px"
            }}>
                <Button sx={{
                    width: "100%",
                }} onClick={() => {
                    guestRoomSubmit()
                    // if (selectedDestination !== null) {
                    handleFind()
                    // }
                }}>Search</Button>
            </Box>
        </Box >
    );
};

export default GuestDropdown